var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-button',{staticClass:"google primary",on:{"click":_vm.importContacts}},[_vm._v(" Sign in with Google ")])}
var staticRenderFns = []

export { render, staticRenderFns }